import React from 'react';
import { Lead, DotPattern, Title } from '../..';
import classnames from 'classnames';

import Bullet from './FeatureBullet';

const FeatureHeader = ({ title, description }: any) => (
  <>
    <Title el="h3">{title}</Title>

    <div className="mt-3 xl:max-w-lg">
      <Lead size="medium">
        <span dangerouslySetInnerHTML={{ __html: description }} />
      </Lead>
    </div>
  </>
);

const FeatureBlock = ({
  title,
  description,
  bullets,
  illustration,
  illustrationIsVideo = false,
  illustrationSide = 'right',
}: any) => (
  <div
    className={classnames('xl:grid xl:grid-cols-2 gap-8 xl:items-center', {
      'xl:grid-flow-row-dense': illustrationSide === 'left',
    })}
  >
    <div
      className={classnames({
        'xl:col-start-2 xl:ml-24': illustrationSide === 'left',
        'relative xl:mr-24': illustrationSide === 'right',
      })}
    >
      <FeatureHeader title={title} description={description} />

      <dl className="mt-10 space-y-10">
        {bullets.map((item) => (
          <Bullet item={item} key={item.name} />
        ))}
      </dl>
    </div>

    <div
      className={classnames('mt-10 -mx-4 relative xl:mt-0', {
        'xl:col-start-1': illustrationSide === 'left',
      })}
      aria-hidden={illustrationSide === 'right'}
    >
      <DotPattern
        className="absolute left-1/2 transform -translate-x-1/2 translate-y-16 xl:hidden hidden"
        width={784}
        height={404}
        aria-hidden={illustrationSide === 'left'}
        id="ca9667ae-9f92-4be7-abcb-9e3d727f2941"
      />

      <div className="flex align-center justify-center px-2 sm:px-0">
        {illustrationIsVideo ? (
          //    <iframe
          //    className="rounded-md w-full h-full"
          //    src={`${illustration.src}?autoplay=0`}
          //    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          //    allowFullScreen
          //  ></iframe>
          // <iframe
          //   width="560"
          //   height="315"
          //   className="rounded-md"
          //   src={`${illustration.src}?autoplay=0`}
          //   allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          //   allowFullScreen
          // ></iframe>
          <video
            preload="auto"
            className="mx-auto rounded-md xl:max-w-2xl border object-cover"
            controls
            poster={illustration?.cover}
          >
            <source src={illustration.src} type="video/mp4" />
            your browser is not supported!
          </video>
        ) : (
          <picture>
            <source srcSet={illustration.webp} type="image/webp" />
            <source srcSet={illustration.png} type="image/png" />
            <img src={illustration.png} alt={illustration.alt} />
          </picture>
        )}
      </div>
    </div>
  </div>
);

const AlternatingFeatureBlockProducts = ({ content }: any) => (
  <div className="relative max-w-6xl mx-auto px-4 sm:px-6 xl:px-8 xl:max-w-7xl">
    <DotPattern
      width={404}
      height={784}
      className="hidden xl:block absolute left-full transform -translate-x-1/2 -translate-y-1/4"
      id="ca9667ae-9f92-4be7-abcb-9e3d727f2941"
    />

    <div className="relative mt-12 sm:mt-16 xl:my-32">
      <FeatureBlock illustrationSide="right" {...content.features[0]} />
    </div>

    {content.features[1] && (
      <>
        <DotPattern
          className="hidden xl:block absolute right-full transform translate-x-1/2 translate-y-12"
          width={404}
          height={784}
          aria-hidden="true"
          id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d"
        />

        <div className="relative mt-12 sm:mt-16 xl:my-32">
          <FeatureBlock illustrationSide="left" {...content.features[1]} />
        </div>
      </>
    )}

    {content.features[2] && (
      <>
        <DotPattern
          width={404}
          height={784}
          className="hidden xl:block absolute left-full transform -translate-x-1/2 -translate-y-1/4"
          id="ca9667ae-9f92-4be7-abcb-9e3d727f2941"
        />

        <div className="relative mt-12 sm:mt-16 xl:my-32">
          <FeatureBlock illustrationSide="right" {...content.features[2]} />
        </div>
      </>
    )}
  </div>
);

export default AlternatingFeatureBlockProducts;
